import API from "api/axiosInstance";
import {
  setIsLoading,
  setListNotifikasi,
  setMessage,
  setStatus,
} from "./index";

export const fetchListNotifikasi = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/notifikasi");
    dispatch(setIsLoading(false));
    dispatch(setListNotifikasi(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchAddNotifikasi = (formData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/send-notification", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error.response.data.message ?? "Ada Kendala di Server"),
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchDeleteNotifikasi = (id) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.delete(`/delete-notification/${id}`);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error.response.data.message ?? "Ada Kendala di Server"),
    );
    dispatch(setStatus("failed"));
  }
};
